import axios, { AxiosInstance } from 'axios'

// API_URL logic:
// 1. Prefer VITE_API_URL env var if set (cleaning trailing /api)
// 2. In Production: Default to '' (relative path), so requests go to https://domain.com/api/...
// 3. In Development: Default to 'http://localhost:8080' if no proxy is configured.
const API_URL = import.meta.env.VITE_API_URL
    ? import.meta.env.VITE_API_URL.replace(/\/api$/, '')
    : (import.meta.env.PROD ? '' : 'http://localhost:8080')

// Create axios instance
const apiClient: AxiosInstance = axios.create({
    baseURL: API_URL,
    timeout: 30000,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
    },
})

// Request interceptor
apiClient.interceptors.request.use(
    (config) => {
        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)

// Response interceptor - Handle errors
apiClient.interceptors.response.use(
    (response) => response,
    async (error) => {
        if (error.response?.status === 401) {
            // Unauthorized - Comentado para evitar bucles de refresh
            // localStorage.removeItem('user')
            // window.location.href = '/login'
            console.error('Sesión inválida o expirada (401)')
        }
        return Promise.reject(error)
    }
)

export default apiClient
